import { ObservableQuery } from '@apollo/client';
import { GroupMember, GroupRole } from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRolesSuccess {
  public static readonly type =
    '[Group/GroupRoles/List] FindAllDefaultRolesSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      listCoreGroupRoles: GroupRole[];
    }>,
    public readonly members: GroupMember[],
  ) {}
}
